import React from 'react'
import Hero from '../Hero/Hero'
import Navbar from '../Navbar/Navbar'
import Features from '../Features/Features'
import CategoryCards from '../CategoryCards/CategoryCards'
import ActionSection from '../ActionSection/ActionSection'
import Footer from '../Footer/Footer'
import MediaSection from '../MediaSection/MediaSection'
import BestSellers from '../BestSellers/BestSellers'
import QualityCertificates from '../QualityCertificates/QualityCertificates'
import AboutSection from '../AboutSection/AboutSection'
import ProductAnalysis from '../ProductAnalysis/ProductAnalysis'
import TechnicalDocuments from '../TechnicalDocuments/TechnicalDocuments'
import BlogSection from '../BlogSection/BlogSection'
import ContactSection from '../ContactSection/ContactSection'

function HomePage() {
  return (
    <div className="relative"> {/* Kapsayıcıya relative vermek iyidir */}
        <Navbar/>
        <Hero/>
        <Features/>
        <QualityCertificates/>
        <AboutSection/>
        <ProductAnalysis/>
        <TechnicalDocuments/>
        <BlogSection/>
        <ContactSection/>
        <Footer/>
    </div>
  )
}

export default HomePage